import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";

function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return "";
  }
}

function isNumber(value: any): boolean {
  return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}


@Injectable()
export class NgbDateFRParserFormatter extends NgbDateParserFormatter {
  public static SEPARATOR = '-';
  public static SEPARATOR_HEURE = ':';

  static sortByProperty(property: any): any {
    return function(x, y) {
      return x[property] === y[property] ? 0 : x[property] > y[property] ? 1 : -1;
    }
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split(NgbDateFRParserFormatter.SEPARATOR);
      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return { year: toInteger(dateParts[0]), month: null, day: null };
      } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        return { year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null };
      } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return { year: toInteger(dateParts[2]), month: toInteger(dateParts[1]), day: toInteger(dateParts[0]) };
      }
    }
    return null;
  }

  parseTime(value: string): NgbTimeStruct {
    if (value) {
      const timeParts = value.trim().split(':')
      console.log(timeParts);
      if (timeParts.length === 3 && isNumber(timeParts[0])) {
        return { hour: toInteger(timeParts[0]), minute: toInteger(timeParts[1]), second: toInteger(timeParts[2]) };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    let stringDate: string = "";
    if (date) {
      stringDate += isNumber(date.day) ? padNumber(date.day) + NgbDateFRParserFormatter.SEPARATOR : "";
      stringDate += isNumber(date.month) ? padNumber(date.month) + NgbDateFRParserFormatter.SEPARATOR : "";
      stringDate += date.year;
    }
    return stringDate;
  }

  getCurrentDate(): string {
    let stringDate: string = "";
    const date = new Date();
    if (date) {
      stringDate += isNumber(date.getFullYear()) ? padNumber(date.getFullYear()) + NgbDateFRParserFormatter.SEPARATOR : "";
      stringDate += isNumber(date.getMonth() + 1) ? padNumber(date.getMonth() + 1) + NgbDateFRParserFormatter.SEPARATOR : "";
      stringDate += date.getDate();
    }
    return stringDate;
  }

  getCurrentDateString(): string {
    let stringDate: string = "";
    const date = new Date();
    if (date.getDate()<10) {
      stringDate += "0"+String(date.getDate())+ NgbDateFRParserFormatter.SEPARATOR;
    }else{ stringDate += String(date.getDate())+ NgbDateFRParserFormatter.SEPARATOR;}

    if (date.getMonth()<9) {
      stringDate += "0"+String(date.getMonth()+1)+ NgbDateFRParserFormatter.SEPARATOR;
    }else{ stringDate += String(date.getMonth()+1)+ NgbDateFRParserFormatter.SEPARATOR;}
    stringDate += String(date.getFullYear());
    return stringDate;
  }



  getCurrentHeure(): string {
    let stringDate: string = "";
    const date = new Date();
    if (date) {
      stringDate += isNumber(date.getHours()) ? padNumber(date.getHours()) + NgbDateFRParserFormatter.SEPARATOR_HEURE : "";
      stringDate += date.getMinutes();
    }
    return stringDate;
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/ngb-date-fr-parser-formatter.ts